import { StringUtil } from '../../../components/utils/string-util/string-util';
import React from 'react';
import { RecallItems } from '../../../services/recalls-service/recalls-service';
import { ExemptWordsListProps } from '../recalls/hook/use-exempt-word-list';

interface Props {
    recall: RecallItems;
    exemptWordsContent: ExemptWordsListProps | null;
}
export const RecallsDataAccordionDescriptionLang = (props: Props) => {
    const descriptionLang = props.exemptWordsContent
        ? StringUtil.sentenceCase(
              props.recall.descriptionLang,
              props.exemptWordsContent
          )
        : StringUtil.sentenceCaseWithoutSanitize(props.recall.descriptionLang);

    return (
        <>
            <div className="support-accordion-description-content">
                {props.recall.descriptionLang ? descriptionLang : ' '}
            </div>
        </>
    );
};
